<template>
<div>
 
  <GdDevice :apiHost="apiHost" v-if="isGd == 'true'" />
  <YLZDevice :apiHost="apiHost" v-if="isYLZ == 'true'" />
  <CPDevice :apiHost="apiHost" v-if="isCP == 'true'" />
  <Device v-if="isGd != 'true' && isYLZ != 'true' && isCP != 'true'"/>
  </div>
</template>

<script>
import GdDevice from "../components/gdDevice";
import Device from "../components/device";
import YLZDevice from '../components/YLZDevice';
import CPDevice from '../components/CPDevice'

export default {
  data() {
    return {
      apiHost:{
        path:this.$route.query.isYLZ ? 'ylzMerchant' : this.$route.query.isCP ? 'canpan' : 'gdMerchant',
        urlQuery: this.$route.query.isYLZ ? "?isYLZ=true": this.$route.query.isCP? "?isCP=true" : "?isGdLl=true"
       },
      isGd: this.$route.query.isGdLl,
      isYLZ: this.$route.query.isYLZ,
      isCP: this.$route.query.isCP,
    };
  },

  methods: {

  },
  components: { GdDevice,Device, YLZDevice, CPDevice },
};
</script>
